import {CalendarEvent} from '../components/SaveToCalendar/types';
import formatDateForCalendarUrl from './formatDateForCalendarUrl';
import getEndTime from './getEndTime';

function generateGoogleCalendarUrl(calendarEvent: CalendarEvent) {
	const startDate = formatDateForCalendarUrl(calendarEvent.startDate);
	const endDate = formatDateForCalendarUrl(getEndTime(calendarEvent));

	return encodeURI(
		[
			'https://www.google.com/calendar/render',
			'?action=TEMPLATE',
			`&text=${calendarEvent.title || ''}`,
			`&dates=${startDate || ''}`,
			`/${endDate || ''}`,
			`&details=${calendarEvent.description || ''}`,
			`&location=${calendarEvent.address || ''}`,
			'&sprop=&sprop=name:',
		].join(''),
	);
}

export default generateGoogleCalendarUrl;
